import eight from '../assets/svg/projects/eight.svg'
import five from '../assets/svg/projects/five.svg'
import myhours from '../assets/svg/projects/myhours.svg'
import strawberry from '../assets/svg/projects/strawberry.svg'
import orbitz from '../assets/svg/projects/orbitz.svg'
import clockify from '../assets/svg/projects/clockify.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'MyHours Clone',
        projectDesc: 'Full stack web application clone built to track project work time, clients, and teams.',
        tags: ['HTML', 'CSS', 'ReactJS', 'Redux', 'ChakraUI', 'NodeJS', 'ExpressJS', 'MongoDB', 'Mongoose'],
        code: 'https://github.com/Hisam-94/bouncy-donkey-4696',
        demo: 'https://myhours01.netlify.app/',
        image: myhours
    },
    {
        id: 2,
        projectName: 'Strawberrynet Clone',
        projectDesc: 'This project about Beauty,Skincare,Makeup,Perfume brand products that lets their customers have a hassle-free and convenient online shopping experience.',
        tags: ['HTML', 'CSS', 'Bootstrap', 'JavaScript'],
        code: 'https://github.com/KalashThakur/straberrynet',
        demo: 'https://imaginative-praline-24d6d4.netlify.app/',
        image: strawberry
    },
    {
        id: 3,
        projectName: 'Clockify',
        projectDesc: 'This project is All about time tracking software which we can measure our tasks on timely basis',
        tags: ['React', 'Redux', 'ChakraUI'],
        code: 'https://github.com/sivagurubilli/equable-pleasure-9638',
        demo: 'https://clockify-clone-guru.netlify.app/',
        image: clockify
    },
    {
        id: 4,
        projectName: 'Orbitz Clone',
        projectDesc: 'Orbitz.com is a is a travel fare aggregator website.',
        tags: ['React', 'Redux', 'Material Ui'],
        code: 'https://github.com/KalashThakur/Orbitz',
        demo: 'https://bucolic-muffin-8abf9f.netlify.app/',
        image: orbitz
    }
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/